export type BolOverallConfidence = "HIGH" | "MEDIUM" | "LOW";

export type BolAutoAction =
  | "Auto-create pickup"
  | "Human verification required"
  | "Human required";

export interface BolFieldValue {
  value: string | number;
  confidence: number;
  aiMessage?: string | null;
  /** Set when the reviewer edits or fills the field — suppresses AI badge */
  humanProvided?: boolean;
}

export interface BolAddressBlock {
  name?: BolFieldValue;
  addressLine_1?: BolFieldValue;
  addressLine_2?: BolFieldValue;
  city?: BolFieldValue;
  state?: BolFieldValue;
  zip?: BolFieldValue;
  phoneNumber?: BolFieldValue;
  email?: BolFieldValue;
}

export interface BolPickupWindow {
  windowDate?: BolFieldValue;
  windowStartTime?: BolFieldValue;
  windowEndTime?: BolFieldValue;
  timeZoneOffset?: BolFieldValue;
}

export interface BolItem {
  type?: BolFieldValue;
  classCode?: BolFieldValue;
  numberOfUnits?: BolFieldValue;
  squareYards?: BolFieldValue;
  weight?: BolFieldValue;
  length?: BolFieldValue;
  width?: BolFieldValue;
  height?: BolFieldValue;
  description?: BolFieldValue;
  notes?: BolFieldValue;
  sidemark?: BolFieldValue;
}

export interface BolDocument {
  bol?: BolFieldValue;
  purchaseOrder?: BolFieldValue;
  orderDescription?: BolFieldValue;
  totalWeight?: BolFieldValue;
  generalNotes?: BolFieldValue;
  pickupWindow?: BolPickupWindow;
  pickupFrom?: BolAddressBlock;
  shipTo?: BolAddressBlock;
  items?: BolItem[];
}

export interface BolEntityResolutionEntry {
  entity_id: string;
  entity_type: string;
  canonical_name: string;
  resolution_layer: number;
  match_score: number;
}

export interface BolEntityResolution {
  shipper?: BolEntityResolutionEntry;
  consignee?: BolEntityResolutionEntry;
  item_signature?: BolEntityResolutionEntry;
  unresolved?: string[];
}

export interface FinalBOLResult {
  document_id: string;
  source_system: string;
  shipper_id: string;
  customer_id: string;
  item_signature: string;
  bol_document: BolDocument;
  overall_confidence: BolOverallConfidence;
  auto_action: BolAutoAction;
  context_sources_used: string[];
  entity_resolution?: BolEntityResolution | null;
}

export function fieldNeedsAttention(f?: BolFieldValue | null): boolean {
  if (!f) return true;
  return f.confidence < 0.85 || !!f.aiMessage;
}

export function formatConfidencePercent(score?: number | null): string {
  if (score == null || Number.isNaN(score)) return "—";
  return `${Math.round(score * 100)}%`;
}

export function fieldHasDisplayValue(f?: BolFieldValue | null): boolean {
  if (!f) return false;
  const v = f.value;
  return v !== "" && v !== null && v !== undefined;
}
